export default __webpack_public_path__ + "static/CormorantGaramond-Light-ce655e648f9bed7ec1e4e38c6a346eb4.woff2";